const ERROR_MESSAGES = {
  GET_FINANCING_TERMS:
    'Unfortunately, there was an error getting your terms. Please try again later.',
  GET_FINANCING_TERMS_TIMEOUT:
    'Unfortunately, there was an error getting your settings. Please try again in a few minutes.'
};

export default ERROR_MESSAGES;
